import Checkbox from '@mui/material/Checkbox';
import * as React from 'react';
import { selectContact } from '../../../../store/conversationGrid';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';

interface Props {
    contactId: number;
    className?: string;
}

export default function TableRowCheckbox({ contactId, className = '' }: Props) {
    const dispatch = useAppDispatch();

    const selectAll = useAppSelector(state => {
        return state.conversationGrid?.selectAll || false;
    });

    const selected = useAppSelector(state => {
        return state.conversationGrid?.selected || [];
    });

    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    React.useEffect(() => {
        const selectStatus = selectAll
            ? !selected.includes(contactId)
            : selected.includes(contactId);

        setIsSelected(selectStatus);
    }, [contactId, selected, selectAll]);

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(selectContact({ contactId, selectStatus: event.target.checked }));
    };

    return (
        <Checkbox
            aria-label="Toggle select contact"
            onChange={handleSelect}
            checked={isSelected}
            className={className}
        />
    );
}
